import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { Card, CardBody } from '../../../../../components/card'
import Checklist from '../../../../../components/checklist'

import styles from './feature-grid-card.module.scss'

const FeatureGridCard = () => {
  const summaryFeatures = [
    <FormattedMessage
      defaultMessage="Obegränsat antal fakturor/offerter"
      id="price.free.feature-grid.unlimited-invoices"
      key="1"
    />,
    <FormattedMessage
      defaultMessage="ROT och RUT med ett klick"
      id="price.free.feature-grid.rot-rut-support-title"
      key="2"
    />,
    <FormattedMessage
      defaultMessage="Stöd för olika valutor"
      id="price.free.feature-grid.different-currencies-title"
      key="3"
    />,
    <FormattedMessage
      defaultMessage="Obegränsat antal kunder/mottagare"
      id="price.free.feature-grid.unlimited-customers"
      key="4"
    />,
    <FormattedMessage defaultMessage="Kortbetalning" id="price.free.feature-grid.card-payment-title" key="5" />,
    <FormattedMessage
      defaultMessage="Skicka fakturor via e-post eller SMS"
      id="price.free.email-or-sms-title"
      key="6"
    />,
    <FormattedMessage defaultMessage="Påminnelser" id="price.free.feature-grid.reminders-title" key="7" />,
    <FormattedMessage defaultMessage="Apple Pay & Google pay" id="price.free.feature-grid.apple-pay-title" key="8" />,
    <FormattedMessage
      defaultMessage="Interaktiv webbfaktura/betallänk"
      id="price.free.feature-grid.interactive-invoices-title-1"
      key="9"
    />,
    <FormattedMessage defaultMessage="Kreditfakturor" id="price.free.feature-grid.credit-invoices-title" key="10" />,
    <FormattedMessage defaultMessage="Fakturamallar" id="price.free.feature-grid.invoice-templates-title" key="11" />,
    <FormattedMessage
      defaultMessage="Omvänd skattskyldighet"
      id="price.free.feature-grid.reverse-skattskyldighet-title"
      key="12"
    />,
    <FormattedMessage
      defaultMessage="Stripe-integration"
      id="price.free.feature-grid.stripe-integration-title"
      key="13"
    />,
    <FormattedMessage defaultMessage="Egen logotyp" id="price.free.feature-grid.own-logo-title" key="14" />,
    <FormattedMessage
      defaultMessage="Periodisk sammanställning"
      id="price.free.feature-grid.periodic-gatheric-title"
      key="15"
    />,
    <FormattedMessage
      defaultMessage="Automatisk avprickning"
      id="price.free.feature-grid.automatic-tallying-title"
      key="16"
    />,
    <FormattedMessage
      defaultMessage="Ladda ned fakturor som PDF"
      id="price.free.feature-grid.download-as-pdf-title"
      key="17"
    />,

    <FormattedMessage defaultMessage="Godkänn offerter tryggt med BankID" id="price.free.feature-grid.18" key="18" />,
    <FormattedMessage defaultMessage="Bifoga bilagor" id="price.free.feature-grid.19" key="19" />,
    <FormattedMessage defaultMessage="Försäljningsöversikt" id="price.free.feature-grid.21" key="21" />,
  ]

  return (
    <Card className={styles.root}>
      <CardBody>
        <FormattedHTMLMessage defaultMessage="Gratis fakturering" id="billing.price.title" tagName="h2" />
        <FormattedHTMLMessage
          defaultMessage="Många funktioner ska inte kosta mycket. Det ska kosta zero, zip, nada."
          id="billing.price.lede"
          tagName="p"
        />
        <div className={styles.seperator} />
        <Checklist col={3} horizontal items={summaryFeatures} />
      </CardBody>
    </Card>
  )
}

export default FeatureGridCard
